import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";

function MenuForms() {
  const token = localStorage.getItem("token");
  const [triggerRerender, setTriggerRerender] = useState(false);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      id: 0,
      name: "",
      formPath: "",
      formCategoryId: "",
      FormSubCategoriesId: "",
    },
  });

  const [navFormData, setNavFormData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");

  const [isFormPathDisabled, setIsFormPathDisabled] = useState(false);

  // const getCategories = async () => {
  //   if (!token) return;
  //   try {
  //     const response = await get("UserAuthentication/GetAllCategory", {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     setCategoryData(response.navCategory);
  //   } catch (error) {
  //     console.error("Error fetching categories:", error);
  //   }
  // };

  // const getSubCategoryList = async (categoryId) => {
  //   if (!token || !categoryId) return;
  //   try {
  //     const formdata = { formCategoryId: categoryId };
  //     const response = await post(
  //       `UserAuthentication/GetAllNavSubCategory`,
  //       formdata,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     setSubCategoryData(response);
  //   } catch (error) {
  //     console.error("Error fetching subcategories:", error);
  //   }
  // };

  // const getNavFormList = async (subCategoryId) => {
  //   if (!token || !subCategoryId) return;
  //   try {
  //     const formdata = { id: subCategoryId };
  //     const response = await post(
  //       `UserAuthentication/GetAllNavForm`,
  //       formdata,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  //     setNavFormData(response);
  //   } catch (error) {
  //     console.error("Error fetching nav forms:", error);
  //   }
  // };

  // useEffect(() => {
  //   getCategories();
  // }, [triggerRerender]);

  // useEffect(() => {
  //   if (selectedCategoryId) {
  //     getSubCategoryList(selectedCategoryId);
  //     setSelectedSubCategoryId(null);
  //   } else {
  //     setSubCategoryData([]);
  //     setNavFormData([]);
  //     setSelectedSubCategoryId(null);
  //   }
  // }, [selectedCategoryId, triggerRerender]);

  // useEffect(() => {
  //   if (selectedSubCategoryId) {
  //     getNavFormList(selectedSubCategoryId);
  //   } else {
  //     setNavFormData([]);
  //   }
  // }, [selectedSubCategoryId, triggerRerender]);

  const getCategories = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategoryData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getSubCategoryList = async (categoryId) => {
    if (!token || !categoryId) return;
    try {
      const formdata = { formCategoryId: categoryId };
      const response = await post(
        `UserAuthentication/GetAllNavSubCategory`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSubCategoryData(response);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const getNavFormList = async (subCategoryId) => {
    if (!token || !subCategoryId) return;
    try {
      const formdata = { id: subCategoryId };
      const response = await post(
        `UserAuthentication/GetAllNavForm`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setNavFormData(response);
    } catch (error) {
      console.error("Error fetching nav forms:", error);
    }
  };

  useEffect(() => {
    getCategories();
  }, [triggerRerender]);

  useEffect(() => {
    if (selectedCategoryId) {
      getSubCategoryList(selectedCategoryId);
    } else {
      setSubCategoryData([]);
      setNavFormData([]);
    }
  }, [selectedCategoryId, triggerRerender]);

  useEffect(() => {
    if (selectedSubCategoryId) {
      getNavFormList(selectedSubCategoryId);
    } else {
      setNavFormData([]);
    }
  }, [selectedSubCategoryId, triggerRerender]);

  const handleCategoryChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`formCategoryId`, null);
      setSelectedCategoryId("");
      setSelectedSubCategoryId(null); // Reset subcategory only if category is cleared
    } else {
      setValue(`formCategoryId`, selectedOption || { value: 0, label: "" });
      setSelectedCategoryId(selectedOption?.value);
    }
    trigger(`formCategoryId`);
  };

  const handleSubCategoryChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setValue(`FormSubCategoriesId`, null);
      setSelectedSubCategoryId(null);
    } else {
      setValue(
        `FormSubCategoriesId`,
        selectedOption || { value: 0, label: "" }
      );
      setSelectedSubCategoryId(selectedOption?.value);
    }
    trigger(`FormSubCategoriesId`);
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: false,
    },
    {
      name: "Name",
      selector: (row) => `${row.name}`,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <>
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleEditClick(row.id)}
            >
              <i className="fas fa-pencil"></i>
            </button>
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleDeleteClick(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </>
      ),
    },
  ];

  const handleEditClick = async (rowId) => {
    var formData = { id: rowId };
    try {
      const response = await post(
        `UserAuthentication/GetNavFormById`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const selectedNavForm = response;

      const selectedCategory = categoryData.find(
        (option) => option.id === response.subCategoryFormId
      );

      const selectedSubCategory = subCategoryData.find(
        (option) => option.id === response.formSubCategoriesId
      );

      reset({
        id: selectedNavForm.id,
        name: selectedNavForm.name,
        formPath: selectedNavForm.formPath,
        formCategoryId: selectedCategory
          ? { value: selectedCategory.id, label: selectedCategory.name }
          : null,
        FormSubCategoriesId: selectedSubCategory
          ? { value: selectedSubCategory.id, label: selectedSubCategory.name }
          : null,
      });

      setSelectedCategoryId(selectedCategory?.id || "");
      setSelectedSubCategoryId(selectedSubCategory?.id || "");
      setIsFormPathDisabled(true);
    } catch (error) {
      console.error("Error fetching navform:", error);
    }
  };

  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Form?"
    );

    if (confirmDelete) {
      const formdata = { id: rowId };
      try {
        const response = await post(
          `UserAuthentication/DeleteNavForm`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        getNavFormList(selectedSubCategoryId);
      } catch (error) {
        console.error("Error deleting navform:", error);
      }
    }
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formdata = {
      ...data,
      formCategoryId: data?.formCategoryId?.value,
      FormSubCategoriesId: data?.FormSubCategoriesId?.value,
      // formCategoryId: selectedCategoryId,
      // FormSubCategoriesId: selectedSubCategoryId,
    };

    // console.log(formdata);
    // return;

    try {
      const response = await post(
        `UserAuthentication/AddUpdateNavForm`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);

        reset({
          id: 0,
          name: "",
          formPath: "",
          formCategoryId: {
            value: selectedCategoryId,
            label:
              categoryData.find((cat) => cat.id === selectedCategoryId)?.name ||
              "",
          },
          FormSubCategoriesId: {
            value: selectedSubCategoryId,
            label:
              subCategoryData.find(
                (subCat) => subCat.id === selectedSubCategoryId
              )?.name || "",
          },
        });

        setIsFormPathDisabled(false);
      }
    } catch (error) {
      console.error("Error saving subcategory:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Forms</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`formCategoryId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={categoryData.map((category) => ({
                          value: category.id,
                          label: category.name,
                        }))}
                        onChange={handleCategoryChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.formCategoryId && (
                    <small className="text-danger">
                      {errors.formCategoryId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Sub Category<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`FormSubCategoriesId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subCategoryData.map((subCategory) => ({
                          value: subCategory.id,
                          label: subCategory.name,
                        }))}
                        onChange={handleSubCategoryChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.FormSubCategoriesId && (
                    <small className="text-danger">
                      {errors.FormSubCategoriesId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Form Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`name`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    Form Path<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`formPath`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={isFormPathDisabled}
                  />
                  {errors.formPath && (
                    <small className="text-danger">
                      {errors.formPath.message}
                    </small>
                  )}
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={navFormData}
                pagination
                dense
                customStyles={customTableStyles}
                // onRowClicked={handleRowClick}
                highlightOnHover={true}
                // pointerOnHover={true}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default MenuForms;
